<!-- TRANSACTION DETAILS -->
<ap-panel *apSecure='[Permissions.ACCESS_ALL_PAYMENTS]'>
  @if (userView) {
    <ap-panel-title>
      <button panel-button (click)='backToTransactions()' type="button" class="btn btn-default button-panel-position">{{ 'USER.TABS.TRANSACTIONS.TRANSACTION_DETAILS.CLOSE_PANEL' | translate }}</button>
      {{ 'USER.TABS.TRANSACTIONS.TRANSACTION_DETAILS.TITLE' | translate }}{{ transaction?.reference }}
    </ap-panel-title>
  }
  <ap-panel-content>
    <div class='form-horizontal form-label-left'>
      <div class='row transaction-details-container'>
        <!-- GENERAL INFORMATIONS -->
        <div class='col-sm-6 col-md-6 col-xs-6'>
          <span class='section panel-role-title' [ngClass]="{ 'user-view': userView }">{{ 'TRANSACTIONS.TRANSACTION_DETAILS.GENERAL_INFORMATIONS.TITLE' | translate }}</span>

          <!-- TRANSACTION REFERENCE -->
          <div class='form-group'>
            <label class='col-sm-5 col-md-5 col-xs-5'>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.GENERAL_INFORMATIONS.REFERENCE' | translate }}</label>
            <div class='col-sm-7 col-md-7 col-xs-7'>{{ transaction?.reference | noData }}</div>
          </div>

          <!-- TRANSACTION TYPE -->
          <div class='form-group'>
            <label class='col-sm-5 col-md-5 col-xs-5'>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.GENERAL_INFORMATIONS.TYPE' | translate }}</label>
            <div class='col-sm-7 col-md-7 col-xs-7'>{{ 'STATUS.TRANSACTIONS.TYPE.' + transaction?.type | translateIfExist: transaction?.type | noData }}</div>
          </div>

          <!-- TRANSACTION CREATION DATE -->
          <div class='form-group'>
            <label class='col-sm-5 col-md-5 col-xs-5'>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.GENERAL_INFORMATIONS.TRANSACTION_DATE' | translate }}</label>
            <div class='col-sm-7 col-md-7 col-xs-7'>{{ transaction?.creationDate | date: "dd/MM/yyyy 'à' HH':'mm" | noData }}</div>
          </div>

          <!-- TRANSACTION USER ID -->
          <div class='form-group'>
            <label class='col-sm-5 col-md-5 col-xs-5'>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.GENERAL_INFORMATIONS.USER' | translate }}</label>
            <div class='col-sm-7 col-md-7 col-xs-7'>
              @if (transaction?.mobilityAccountId) {
                <code>{{ transaction.mobilityAccountId }}</code>
                <button (click)='navigateToUser(transaction.mobilityAccountId)' class='btn btn-xs btn-default user-button-dialog'><i class='fa fa-user'></i></button>
              } @else {
                -
              }
            </div>
          </div>

          <!-- TRANSACTION PAYMENTMEAN TYPE -->
          <div class='form-group'>
            <label class='col-sm-5 col-md-5 col-xs-5'>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.GENERAL_INFORMATIONS.PAYMENTMEAN' | translate }}</label>
            <div class='col-sm-7 col-md-7 col-xs-7'>{{ ('STATUS.TRANSACTIONS.PAYMENTMEAN_TYPE.' + transaction?.paymentMeanType | translate) + (transaction?.paymentMeanLabel ?  ' ' + transaction?.paymentMeanLabel : '') }}</div>
          </div>

          <!-- TRANSACTION AMOUNT -->
          <div class='form-group'>
            <label class='col-sm-5 col-md-5 col-xs-5'>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.GENERAL_INFORMATIONS.AMOUNT' | translate }}@if (transaction.amountRefunded) {
              <span class='text-primary'> ({{ 'TRANSACTIONS.TRANSACTION_DETAILS.GENERAL_INFORMATIONS.REFUNDED' | translate }})</span>
            }</label>
            <div class='col-sm-7 col-md-7 col-xs-7'>{{ transaction.amount | apCurrency | noData }}@if (transaction.amountRefunded) {
              <span class='text-primary refund-value'> ({{ transaction?.amountRefunded | apCurrency | noData }})</span>
            }</div>
          </div>

          <!-- TRANSACTION VENDOR -->
          <div class='form-group'>
            <label class='col-sm-5 col-md-5 col-xs-5'>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.GENERAL_INFORMATIONS.VENDOR' | translate }}</label>
            <div class='col-sm-7 col-md-7 col-xs-7'>{{ transaction?.vendor | noData }}</div>
          </div>

          <!-- TRANSACTION STATUS -->
          <div class='form-group'>
            <label class='col-sm-5 col-md-5 col-xs-5'>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.GENERAL_INFORMATIONS.STATUS' | translate }}</label>
            <div class='col-sm-7 col-md-7 col-xs-7'>
              @if (transaction?.status === PaymentStatus.PENDING) {
                <status-label type='TRANSACTIONS.STATUS' [status]='transaction.status' hasTooltip='true' tooltipContent="{{ 'TRANSACTIONS.LIST.TOOLTIP.STATUS_PENDING' | translate }}"></status-label>
              } @else {
                <status-label type='TRANSACTIONS.STATUS' [status]='transaction?.status'></status-label>
              }
              @if (transaction?.status === PaymentStatus.FAILED && ([PaymentType.PURCHASE, PaymentType.SUBSCRIPTION_INVOICE].includes(transaction?.type))) {
                <button *apSecure='[Permissions.MANAGE_EXTERNAL_REGULARIZATION]' (click)='openRecoverExternallyDialog()' class='btn btn-xs btn-default regularize-button'>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.GENERAL_INFORMATIONS.REGULARIZE_EXTERNALLY_BUTTON' | translate }}</button>
              }
            </div>
          </div>

          <!-- TRANSACTION COMMENT -->
          @if (transaction?.comment) {
            <div class='form-group'>
              <label class='col-sm-5 col-md-5 col-xs-5'>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.GENERAL_INFORMATIONS.COMMENT' | translate }}</label>
              <div class='col-sm-7 col-md-7 col-xs-7'>{{ transaction.comment }}</div>
            </div>
          }

          <!-- TRANSACTION NEXT ATTEMPT DATE -->
          @if (transaction?.nextAttemptDate) {
            <div class='form-group'>
              <label class='col-sm-5 col-md-5 col-xs-5'>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.GENERAL_INFORMATIONS.NEXT_ATTEMPT_DATE' | translate }}</label>
              <div class='col-sm-7 col-md-7 col-xs-7'>{{ transaction.nextAttemptDate | date: "dd/MM/yyyy 'à' HH':'mm" }}</div>
            </div>
          }

          <!-- TRANSACTION GROUP ID -->
          @if (transaction?.groupId) {
            <div class='form-group'>
              <label class='col-sm-5 col-md-5 col-xs-5'>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.GENERAL_INFORMATIONS.GROUP_ID' | translate }}</label>
              <div class='col-sm-7 col-md-7 col-xs-7'>{{ transaction.groupId }}</div>
            </div>
          }
        </div>

        <!-- TECHNICAL INFORMATIONS -->
        <div class='col-sm-6 col-md-6 col-xs-6'>
          <span class='section panel-role-title col-sm-12 col-md-12 col-xs-12' [ngClass]="{ 'user-view': userView }">{{ 'TRANSACTIONS.TRANSACTION_DETAILS.TECHNICAL_INFORMATIONS.TITLE' | translate }}</span>

          <!-- TRANSACTION PAYMENT ID -->
          <div class='form-group'>
            <label class='col-sm-6 col-md-6 col-xs-6'>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.TECHNICAL_INFORMATIONS.TRANSACTION_ID' | translate }}</label>
            @if (transaction?.paymentId) {
              <div class='col-sm-6 col-md-6 col-xs-6'><code>{{ transaction.paymentId }}</code></div>
            } @else {
              <div class='col-sm-6 col-md-6 col-xs-6'>-</div>
            }
          </div>

          <!-- TRANSACTION PAYMENTMEAN ID -->
          <div class='form-group'>
            <label class='col-sm-6 col-md-6 col-xs-6'>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.TECHNICAL_INFORMATIONS.PAYMENTMEAN_ID' | translate }}</label>
            @if (transaction?.paymentMeanId) {
              <div class='col-sm-6 col-md-6 col-xs-6'><code>{{ transaction.paymentMeanId }}</code></div>
            } @else {
              <div class='col-sm-6 col-md-6 col-xs-6'>-</div>
            }
          </div>

          <!-- TRANSACTION PAYMENTMEAN REFERENCE -->
          <div class='form-group'>
            <label class='col-sm-6 col-md-6 col-xs-6'>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.TECHNICAL_INFORMATIONS.CIT_TRANSACTION_ID' | translate }}</label>
            <div class='col-sm-6 col-md-6 col-xs-6'>{{ transaction?.transactionId | noData }}</div>
          </div>

          <!-- TRANSACTION CUSTOMER REFERENCE -->
          <div class='form-group'>
            <label class='col-sm-6 col-md-6 col-xs-6'>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.TECHNICAL_INFORMATIONS.CUSTOMER_REFERENCE' | translate }}</label>
            <div class='col-sm-6 col-md-6 col-xs-6'>{{ transaction?.customerReference | noData }}</div>
          </div>

          <!-- TRANSACTION LABEL -->
          <div class='form-group'>
            <label class='col-sm-6 col-md-6 col-xs-6'>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.TECHNICAL_INFORMATIONS.LABEL' | translate }}</label>
            <div class='col-sm-6 col-md-6 col-xs-6'>{{ transaction?.label | noData }}</div>
          </div>

          <!-- TRANSACTION CATEGORY -->
          <div class='form-group'>
            <label class='col-sm-6 col-md-6 col-xs-6'>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.TECHNICAL_INFORMATIONS.CATEGORY' | translate }}</label>
            <div class='col-sm-6 col-md-6 col-xs-6'>{{ transaction?.category | noData }}</div>
          </div>

          <!-- TRANSACTION STATUS DATE -->
          <div class='form-group'>
            <label class='col-sm-6 col-md-6 col-xs-6'>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.TECHNICAL_INFORMATIONS.STATUS_DATE' | translate }}</label>
            <div class='col-sm-6 col-md-6 col-xs-6'>{{ transaction?.statusDate | date: "dd/MM/yyyy 'à' HH':'mm" | noData }}</div>
          </div>

          <!-- TRANSACTION STATUS DETAILS -->
          <div class='form-group'>
            <label class='col-sm-6 col-md-6 col-xs-6'>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.TECHNICAL_INFORMATIONS.STATUS_DETAILS' | translate }}</label>
            <div class='col-sm-6 col-md-6 col-xs-6'>{{ 'STATUS.TRANSACTIONS.STATUS_DETAILS.' + transaction?.statusDetail | translateIfExist: transaction?.statusDetail | noData }}</div>
          </div>

          <!-- TRANSACTION MODIFICATION DATE -->
          <div class='form-group'>
            <label class='col-sm-6 col-md-6 col-xs-6'>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.TECHNICAL_INFORMATIONS.MODIFICATION_DATE' | translate }}</label>
            <div class='col-sm-6 col-md-6 col-xs-6'>{{ transaction?.modificationDate | date: "dd/MM/yyyy 'à' HH':'mm" | noData }}</div>
          </div>
        </div>
      </div>
    </div>
  </ap-panel-content>
</ap-panel>

<!-- RECOVERED BY -->
<ap-transaction-details-recovers [userView]='userView' [transaction]='transaction'></ap-transaction-details-recovers>

<!-- PAYMENT ATTEMPTS -->
<ap-transaction-details-attempts [userView]='userView' [transaction]='transaction'></ap-transaction-details-attempts>

<!-- ORDER OF THE TRANSACTION -->
<ap-transaction-details-orders [order]='order' [userView]='userView' [transaction]='transaction'></ap-transaction-details-orders>

<!-- REFUNDS -->
<ap-transaction-details-refunds [userView]='userView' [transaction]='transaction'></ap-transaction-details-refunds>

<!-- INITIAL TRANSACTION REFUND -->
<ap-initial-transaction-details-refunded [userView]='userView' [transaction]='transaction'></ap-initial-transaction-details-refunded>

<!-- INITIAL TRANSACTION RECOVERED -->
<ap-initial-transaction-details-recovered [userView]='userView' [transaction]='transaction'></ap-initial-transaction-details-recovered>
